import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import {connect} from 'react-redux';
import baseStyles from '../../PropertiesMenuStyles';
import {TYPES, PROPERTY_PANELS, BORDER_PANEL_TYPE} from 'crazyEditor/core/constants/panelConstants';
import {openLazyPanel} from 'crazyEditor/redux/modules/panel/panel';
import SelectField from 'material-ui/SelectField';
import { getElementMethods } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { updateDesktopElement } from 'crazyEditor/redux/modules/element/actions/desktopElementActions';
import CustomSvgButtonWithTextPropMenu from '../../shared/CustomSvgButtonWithTextPropMenu';

@connect(
  false,
  {openLazyPanel, updateDesktopElement}
)
@Radium
export default class BorderProperty extends Component {

  openFontPanel = (event, panel, panelProps = {}) => {
    const {openLazyPanel, selectedElementIds, selectedElements} = this.props;
    openLazyPanel(panel, TYPES.PROPERTY_PANEL, event.currentTarget, {
      selectedElementIds: selectedElementIds,
      selectedElements: selectedElements,
      ...panelProps
    });
  };

  updateElement = (updateGetter) => {
    const {updateDesktopElement} = this.props;
    const element = this.props.selectedElements[0];
    updateDesktopElement(element.id, updateGetter(element));
  };

  render() {
    const {selectedElements, elementDefinitionProps} = this.props;
    return (
      <div style={[baseStyles.menuContainer, this.props.first && baseStyles.menuContainerFirst]}>
        <div style={baseStyles.menuTitle}>Border</div>
        <div style={baseStyles.menuBody}>
          <CustomSvgButtonWithTextPropMenu label="Color"
                                           iconWidth="28px"
                                           iconHeight="28px"
                                           lineBackground={_.get(selectedElements[0], 'compProps.borderColor') || 'transparent'}
                                           onClick={(event) => this.openFontPanel(event, PROPERTY_PANELS.COLOR, {propNameToUpdate: 'compProps.borderColor'})}
                                           iconPath="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"/>

          <CustomSvgButtonWithTextPropMenu label="Size"
                                           iconWidth="36px"
                                           iconHeight="36px"
                                           onClick={(event) => this.openFontPanel(event, PROPERTY_PANELS.BORDER_WIDTH)}
                                           iconPath="M3,17H21V15H3V17M3,20H21V19H3V20M3,13H21V10H3V13M3,4V8H21V4H3Z"/>

          <CustomSvgButtonWithTextPropMenu label="Style"
                                           iconWidth="36px"
                                           iconHeight="36px"
                                           onClick={(event) => this.openFontPanel(event, PROPERTY_PANELS.BORDER, {type: BORDER_PANEL_TYPE.TYPE})}
                                           iconPath="M3,16H8V14H3V16M9.5,16H14.5V14H9.5V16M16,16H21V14H16V16M3,20H5V18H3V20M7,20H9V18H7V20M11,20H13V18H11V20M15,20H17V18H15V20M19,20H21V18H19V20M3,12H11V10H3V12M13,12H21V10H13V12M3,4V8H21V4H3Z"/>
          {
            !elementDefinitionProps.noBorderRadius &&
            <CustomSvgButtonWithTextPropMenu label="Corners"
                                             iconWidth="36px"
                                             iconHeight="36px"
                                             onClick={(event) => this.openFontPanel(event, PROPERTY_PANELS.BORDER_RADIUS)}
                                             iconPath="M19,19H21V21H19V19M19,17H21V15H19V17M3,13H5V11H3V13M3,17H5V15H3V17M3,9H5V7H3V9M3,5H5V3H3V5M7,5H9V3H7V5M15,21H17V19H15V21M11,21H13V19H11V21M15,21H17V19H15V21M7,21H9V19H7V21M3,21H5V19H3V21M21,8A5,5 0 0,0 16,3H11V5H16A3,3 0 0,1 19,8V13H21V8Z"/>

          }
          <CustomSvgButtonWithTextPropMenu label="Shadows"
                                           iconWidth="36px"
                                           iconHeight="36px"
                                           onClick={(event) => this.openFontPanel(event, PROPERTY_PANELS.SHADOW)}
                                           iconPath="M3,3H18V18H3V3M19,19H21V21H19V19M19,16H21V18H19V16M19,13H21V15H19V13M19,10H21V12H19V10M19,7H21V9H19V7M16,19H18V21H16V19M13,19H15V21H13V19M10,19H12V21H10V19M7,19H9V21H7V19Z"/>
          {
            elementDefinitionProps.paddingSelectable &&
            <CustomSvgButtonWithTextPropMenu label="Padding"
                                             iconWidth="30px"
                                             iconHeight="30px"
                                             iconProps={{
                                               viewBox: '0 0 30 30'
                                             }}
                                             onClick={(event) => this.openFontPanel(event, PROPERTY_PANELS.PADDING)}
                                             iconPath="M1.64,0H3.36V3.36H0V1.64A1.6,1.6,0,0,1,1.64,0ZM0,6.64H3.36V10H0V6.64Zm0,6.72H3.36v3.28H0V13.36ZM0,20H3.36v3.36H0V20ZM1.64,30A1.6,1.6,0,0,1,0,28.36V26.64H3.36V30H1.64Zm5-26.64V0H10V3.36H6.64ZM6.64,30V26.64H10V30H6.64ZM13.36,3.36V0h3.28V3.36H13.36Zm0,26.64V26.64h3.28V30H13.36ZM20,3.36V0h3.36V3.36H20ZM20,30V26.64h3.36V30H20ZM28.36,0A1.6,1.6,0,0,1,30,1.64V3.36H26.64V0h1.72ZM30,6.64V10H26.64V6.64H30Zm0,6.72v3.28H26.64V13.36H30ZM30,20v3.36H26.64V20H30Zm0,8.36A1.6,1.6,0,0,1,28.36,30H26.64V26.64H30v1.72ZM17,20H12l-1,3H7L13,7h3l6,16H18Zm-4.23-3h3.44L14.5,11.5Z"/>
          }
        </div>
      </div>
    );
  }
}

BorderProperty.propTypes = {
  selectedElementIds: PropTypes.array.isRequired,
  selectedElements: PropTypes.array.isRequired,
  elementDefinitionProps: PropTypes.object.isRequired,
};